module.exports = "<span class=\"c-title-switcher__button\" (click)='openFinder($event)' >\n  <span class=\"c-title-switcher__button-label\">{{title}}</span>\n  <span class=\"c-title-switcher__button-icon\"></span>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/title-switcher/title-switcher.component.html
// module id = ./src/app/modules/common-module/components/title-switcher/title-switcher.component.html
// module chunks = 9